import { AccordionDetailsProps, default as MuiAccordionDetails } from '@mui/material/AccordionDetails'
import * as React from 'react'

const AccordionDetails: React.FC<React.PropsWithChildren<AccordionDetailsProps>> = (props) => {
  return <MuiAccordionDetails {...props} />
}

export default AccordionDetails
